export default "__VITE_ASSET__Dvz32xvU__"